// extracted by mini-css-extract-plugin
export default {"root":"detail_root__9Ir8s"};